import IconButton from '@/shared/components/IconButton/IconButton'
import Loader from '@/shared/components/Loader/Loader'
import styles from './OptionsTile.module.scss'

interface OptionsTileProps {
  onEdit: () => void
  onDelete: () => void
  /** The row's record is being fetched for the edit form. */
  isEditLoading?: boolean
}

function OptionsTile(props: OptionsTileProps) {
  const { onEdit, onDelete, isEditLoading } = props

  return (
    <div className={`${styles.OptionsTileWrapper}`}>
      {/*
        The edit form opens on data, so between the click and the modal there is
        a silent wait that reads as a dead button. The spinner takes the pencil's
        place rather than sitting beside it — same 14px box, so the bin does not
        move — and the button is disabled meanwhile, which also stops the second
        click that used to queue up behind the first.
      */}
      <IconButton
        icon={isEditLoading ? <Loader size="tiny" /> : 'las la-pen icon-small'}
        onClick={onEdit}
        color="primary"
        disabled={isEditLoading}
      />
      <IconButton
        icon="las la-trash icon-small"
        onClick={onDelete}
        color="primary"
      />
    </div>
  )
}

export default OptionsTile
